import React from 'react'
import { Grid, Typography } from '@mui/material'
import { Check } from '@mui/icons-material'

import useStyles from './style'

type Props = {
  title: string
  rulesCheck: Array<any>
  password: string
}

const RulesRecoverPassword = (props: Props) => {
  const { title, rulesCheck, password } = props
  const classes = useStyles()

  return (
    <Grid container className={classes.container}>
      <Grid item lg={12} md={12} xs={12}>
        <Typography variant="h6" color="secondary.contrastText">
          {title}
        </Typography>
      </Grid>
      {rulesCheck
        .filter((rule) => rule.state)
        .map((rule) => (
          <Grid
            item
            lg={6}
            md={6}
            xs={12}
            key={rule.key}
            style={{ display: 'flex', alignItems: 'center', margin: '5px 0px' }}
          >
            <Check color="primary" sx={{ marginRight: '5px' }} />
            <Typography
              variant="subtitle1"
              color="secondary.contrastText"
              style={{ opacity: rule.validate(password) ? '1' : '0.5' }}
            >
              {rule.label}
            </Typography>
          </Grid>
        ))}
    </Grid>
  )
}

export default RulesRecoverPassword
